import { useMemo } from 'react';
import _get from 'lodash/get';
import { useParams } from 'react-router-dom';
import Loading from '@/components/general/Loading';
import useApiFetch from '@/hooks/useApiFetch';
import checkinReports from '@/services/checkinReports';
import { FetchApiIds } from '@/types';
import { CheckinSummary } from '@/types/api';
import UserCheckinsPage from './UserCheckins.component';

const UserCheckinsContainer = function (): JSX.Element {
  const { userId } = useParams();

  const currentUserCheckins = useApiFetch<CheckinSummary[]>(
    FetchApiIds.ALL_CHECKINS,
    checkinReports.getAllUsersCheckins
  );

  const userCheckinsByIdForAdmin = useApiFetch<CheckinSummary[]>(
    [FetchApiIds.CHECKIN_BY_ID_FOR_ADMIN, userId],
    async () => checkinReports.getUserCheckinsByIdForAdmin(userId as string),
    { enabled: !!userId }
  );

  const checkins = useMemo(() => {
    if (userId) {
      return userCheckinsByIdForAdmin.data ?? [];
    }
    return currentUserCheckins?.data ?? [];
  }, [currentUserCheckins?.data, userCheckinsByIdForAdmin.data, userId]);

  const username = useMemo(() => {
    return _get(checkins, '[0].user.name', 'User');
  }, [checkins]);

  if (currentUserCheckins.isLoading || userCheckinsByIdForAdmin.isLoading) {
    return <Loading fullPage />;
  }

  return (
    <UserCheckinsPage
      userId={userId}
      username={username}
      checkins={checkins}
      isLoggedUserCheckinsPage={!userId}
    />
  );
};

export default UserCheckinsContainer;
